<template>
  <b-card>
    <b-tabs
      :vertical="window.width >= 407 ? false : true"
      nav-wrapper-class="w-100"
    >
      <b-tab title="سامان ۱" active>
        <list-table
          url="get-depositeList/Saman"
          title="گزارش صورتحساب سامان ۱"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="سامان ۲">
        <list-table
          url="get-depositeList/Saman2"
          title="گزارش صورتحساب سامان ۲"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="صادرات">
        <list-table
          url="get-depositeList/Saderat"
          title="گزارش صورتحساب صادرات"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "depositStatement",
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      merchants: [],
      url: "inandout?typeofpayment=2",
      params: [
        {
          label: "تاریخ",
          field: "date",
          type: "date-picker",
          value: persianDate.getDate(new Date()),
        },
      ],
      fields: [
        {
          key: "referenceNumber",
          label: "کد رهگیری",
        },
        {
          key: "transferAmount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "description",
          label: "توضیحات",
        },
        {
          key: "balance",
          label: "موجودی",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گزارش  صورتحساب" }]);
  },
  components: {
    "list-table": TableShowData,
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>